// Format a number for JSON key: remove trailing .0, keep .25/.5/.75
export const formatMeasurementKey = (num) => {
  const n = Number(num)
  if (Number.isInteger(n)) return n.toString()
  const str = n.toFixed(2)
  if (str.endsWith('0')) return n.toFixed(1).replace(/\.0$/, '')
  return str.replace(/0+$/, '')
}
import TagManager from 'react-gtm-module'

import AUcups from './data/au/AU-cups.json'
import EUcups from './data/EUcups.json'
import FRcups from './data/fr/FR-cups.json'
import ITcups from './data/it/IT-cups.json'
import UKcups from './data/uk/UK-cups.json'
import UScups from './data/us/US-cups.json'
import AUBandSizes from '../src/data/au/AU-bands.json'
import bandSizes from '../src/data/EUbandsizes.json'
import FRBandSizes from '../src/data/fr/FR-bands.json'
import ITBandSizes from '../src/data/it/IT-bands.json'
import UKBandSizes from '../src/data/uk/UK-bands.json'
import USBandSizes from '../src/data/us/US-bands.json'

export const handleGetSizes = (inputBustMeasurement, inputBandMeasurement, bandSize, chart, setCup) => {
  let contempArr = []
  if (bandSize) {
    for (let band of bandSize) {
      let cup = ''
      if (
        inputBandMeasurement.includes('<') ||
        inputBandMeasurement.includes('>') ||
        inputBustMeasurement.includes('<') ||
        inputBustMeasurement.includes('>')
      ) {
        return ['size unavailable']
      }
      if (chart === 'eu') {
        cup = EUcups[band][inputBustMeasurement] ?? ''
      } else if (chart === 'uk') {
        cup = UKcups[band][inputBustMeasurement] ?? ''
      } else if (chart === 'us') {
        cup = UScups[band][inputBustMeasurement] ?? ''
      } else if (chart === 'au') {
        cup = AUcups[band][inputBustMeasurement] ?? ''
      } else if (chart === 'fr') {
        cup = FRcups[band][inputBustMeasurement] ?? ''
      } else if (chart === 'it') {
        cup = ITcups[band][inputBustMeasurement] ?? ''
      }
      if (cup) {
        setCup(cup)
        const bandAndCup = getBandAndCup(band, cup)
        for (let bc of bandAndCup) {
          contempArr.push(bc)
        }
      } else {
        setCup('')
      }
    }
  }

  if (contempArr.length > 0) {
    return contempArr
  } else {
    return []
  }
}

export const handleGetAlternativeSizes = (inputBustMeasurement, inputBandMeasurement, bandSize, chart) => {
  let contempArr = []
  const inchesCharts = ['uk', 'us']
  let cup = ''

  const smallerBandSize =
    chart === 'it'
      ? String(parseInt(bandSize) - 1)
      : inchesCharts.includes(chart)
      ? String(parseInt(bandSize) - 2)
      : String(parseInt(bandSize) - 5)

  const diffRange = inchesCharts.includes(chart) ? 0.25 : 1
  const formattedBandMeasurement = formatMeasurementKey(parseFloat(inputBandMeasurement) - diffRange)
  const formattedBustMeasurement = formatMeasurementKey(inputBustMeasurement)

  if (chart === 'eu') {
    const findBandSizeValue = findBandSize(formattedBandMeasurement, bandSizes)
    if (findBandSizeValue && findBandSizeValue[0] === smallerBandSize) {
      cup = EUcups[smallerBandSize][formattedBustMeasurement]
    }
  } else if (chart === 'uk') {
    const findBandSizeValue = findBandSize(formattedBandMeasurement, UKBandSizes)
    if (findBandSizeValue && findBandSizeValue[0] === smallerBandSize) {
      cup = UKcups[smallerBandSize][formattedBustMeasurement]
    }
  } else if (chart === 'us') {
    const findBandSizeValue = findBandSize(formattedBandMeasurement, USBandSizes)
    if (findBandSizeValue && findBandSizeValue[0] === smallerBandSize) {
      cup = UScups[smallerBandSize][formattedBustMeasurement]
    }
  } else if (chart === 'au') {
    const findBandSizeValue = findBandSize(formattedBandMeasurement, AUBandSizes)
    if (findBandSizeValue && findBandSizeValue[0] === smallerBandSize) {
      cup = AUcups[smallerBandSize][formattedBustMeasurement]
    }
  } else if (chart === 'fr') {
    const findBandSizeValue = findBandSize(formattedBandMeasurement, FRBandSizes)
    if (findBandSizeValue && findBandSizeValue[0] === smallerBandSize) {
      cup = FRcups[smallerBandSize][formattedBustMeasurement]
    }
  } else if (chart === 'it') {
    const findBandSizeValue = findBandSize(formattedBandMeasurement, ITBandSizes)
    if (findBandSizeValue && findBandSizeValue[0] === smallerBandSize) {
      cup = ITcups[smallerBandSize][formattedBustMeasurement]
    }
  }

  if (cup) {
    // When there are 2 cup sizes, only recommend the larger one (array[1])
    const cupToUse = cup.length === 2 ? [cup[1]] : cup
    const bandAndCup = getBandAndCup(smallerBandSize, cupToUse)
    for (let bc of bandAndCup) {
      contempArr.push(bc)
    }
  }

  return {
    sizes: contempArr.length > 0 ? contempArr : [],
    cup: cup && cup.length === 2 ? cup[1] : cup || '',
    alternativeBandSize: cup ? smallerBandSize : '',
    isAvailable: contempArr.length > 0 && cup !== '',
  }
}

const getBandAndCup = (band, cup) => {
  const bc = []
  for (let c of cup) {
    bc.push(band + c)
  }
  return bc
}

export const optionsRange = (start, stop, incr) => {
  let opts = []
  for (let i = start; i <= stop; ) {
    opts.push(i)
    i += incr
  }
  return opts
}

export const getChart = (query) => {
  switch (query) {
    case 'gb':
    case 'uk':
    case 'ie':
      return 'uk'
    case 'au':
    case 'nz':
      return 'au'
    case 'fr':
    case 'pt':
    case 'es':
    case 'mx':
    case 'cl':
      return 'fr'
    case 'us':
    case 'ca':
      return 'us'
    case 'it':
    case 'cz':
      return 'it'
    default:
      return 'eu'
  }
}

const pushToDataLayer = (data) => {
  TagManager.dataLayer(data)
}

export const sendInputToGTM = (event, inputBustMeasurement, inputBandMeasurement, sizes, isAlternativeSize = false) => {
  pushToDataLayer({
    dataLayer: {
      event: event,
      input_band: inputBandMeasurement,
      input_bust: inputBustMeasurement,
      combined_measurements: inputBandMeasurement + '-' + inputBustMeasurement,
      size_suggestion: sizes,
      match: event === 'size_suggestion_success' ? true : false,
      alternative_size: isAlternativeSize,
    },
  })
}

export const getRange = (bandSize, chart) => {
  let useChart
  if (chart === 'eu') {
    useChart = EUcups
  } else if (chart === 'uk') {
    useChart = UKcups
  } else if (chart === 'us') {
    useChart = UScups
  } else if (chart === 'au') {
    useChart = AUcups
  } else if (chart === 'fr') {
    useChart = FRcups
  } else if (chart === 'it') {
    useChart = ITcups
  }
  const arr = Object.keys(useChart[bandSize])
  return arr.sort((a, b) => a - b)
}

export const linkToBras = (size, bandSize, cup) => {
  if (size.length === 1) {
    return `https://www.missmary.com/bra/?size_cup_type=${cup[0]}&size_type=${bandSize}`
  } else if (size.length === 2) {
    return `https://www.missmary.com/bra/?size_cup_type=${cup[0]}&size_cup_type=${cup[1]}&size_type=${bandSize}`
  } else {
    return 'https://www.missmary.com/bra/'
  }
}

export const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  })
}

export const findSmallestOrLargestMeasurement = (obj, order = 'asc') => {
  const keys = Object.keys(obj)
  const smallest = Math.min(...keys)
  const largest = Math.max(...keys)
  return order === 'asc' ? smallest : largest
}

export const findBandSize = (inputBandMeasurement, chartToUse) => {
  if (inputBandMeasurement.includes('<')) {
    const smallest = Math.min(...Object.keys(chartToUse).map((key) => +key))
    return chartToUse[smallest]
  } else if (inputBandMeasurement.includes('>')) {
    const largest = Math.max(...Object.keys(chartToUse).map((key) => +key))
    return chartToUse[largest]
  }
  return chartToUse[inputBandMeasurement]
}
